export interface GovernmentSalePercentageOption {
  value: number;
  label: string;
}

export const GovernmentSalePercentageOptions: GovernmentSalePercentageOption[] = [
  {
    value: 1,
    label: 'até 10%',
  },
  {
    value: 2,
    label: 'de 10% à 20%',
  },
  {
    value: 3,
    label: 'de 20% à 50%',
  },
  {
    value: 4,
    label: 'de 50% à 80%',
  },
  {
    value: 5,
    label: 'de 80% à 100%',
  },
];
